const jquery = $;

const handleSetRealizationImagesSequence = () => {
  let sequence = 1;

  $('.realization-images-sortable-list')
    .children()
    .each(function () {
      const inputSequence = $(this).find('input[name*="sequence"]');
      inputSequence.val(sequence++)
    })
}

const handleSetRealizationImagesRowStart = () => {
  let row = 1;

  $('.realization-images-sortable-list')
    .children()
    .each(function () {
      const rowStartInfo = $(this).find('[data-type="rowStart"]');

      const inputOption = $(this).find('select[name*="option"]');
      const optionValue = inputOption.val();

      const inputRowStart = $(this).find('input[name*="rowStart"]');

      if (optionValue === '1' && row > 1) row--;

      inputRowStart.val(row);
      rowStartInfo.html(`${row} |`);

      row++
    })
}

const handleSetRealizationImagesSort = () => {
  handleSetRealizationImagesSequence();
  handleSetRealizationImagesRowStart();
}

$.fn.extend({
  handleInitRealizationImagesSortableList() {
    handleSetRealizationImagesSort()

    const sortableLists = document.querySelectorAll('.realization-images-sortable-list');

    if (sortableLists) {
      $(document).on('collection-form-add', () => handleSetRealizationImagesSort());
      $(document).on('collection-form-delete', () => handleSetRealizationImagesSort());
    }

    $('select[name*="option"]').on('change', () => handleSetRealizationImagesSort())

    sortableLists.forEach(sortableList => {
      Sortable.create(sortableList, {
        onEnd: handleSetRealizationImagesSort
      });
    })
  },
});

jquery(document).ready(() => {
  jquery(document).handleInitRealizationImagesSortableList();
});
